import { Deserializable } from '../protocols/deserializable';
import { DateUtils } from '../../utils/date-utils';

export class MonthlyPensionAccountNote implements Deserializable {
  public id!: string;
  public paymentInstructionId!: string;
  public authorId!: number;
  public authorName!: string;
  public note!: string;
  public createdDate!: string;

  // Not from API
  public formattedDate!: string;

  public onDeserialize(): void {
    this.formattedDate = DateUtils.formatISOStringToCurrentDateTimeWithoutTimeZone(this.createdDate);
  }
}
